import { LoggerConfig, NgxLoggerLevel } from 'ngx-logger';
import { environment } from 'src/environments/environment';

/**
 * configLogger
 * @returns returns
 */
export const configLogger: () => LoggerConfig = (): LoggerConfig => {
  const win: any = window;
  const parametersLogger: LoggerConfig = {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    // serverLoggingUrl: '/api/log'
    serverLoggingUrl: environment.endpoints.urlBase + environment.endpoints.log.name
  };
  if (win.appEnv) {
    parametersLogger.level = win.appEnv.level || NgxLoggerLevel.DEBUG;
    parametersLogger.serverLogLevel = win.appEnv.serverLogLevel || NgxLoggerLevel.ERROR;
    parametersLogger.serverLoggingUrl = win.appEnv.serverLoggingUrl || '/api/log';
  }
  return parametersLogger;
};
